export default "__VITE_ASSET__hoeD6_1S__"